<template>

    <div class="container-fluid">

        <div id="builder" class="row justify-content-center">
            <div class="col">
                <div class="card tab-content">
                    <div class="card-header">
    
                        <div class="row d-flex">

                            <div class="col-2 col-sm-3 order-1 order-sm-0">
                              
                            </div>

                            <div class="col-12 col-sm-6 order-0 order-sm-1">
                              <h4 class="pt-2 mb-0 pb-1 text-center"><span class="automation-name" @click="">{{ automationName }}</span></h4>
                            </div>

                            <div class="col-10 col-sm-3 order-2 order-sm-2 pr-0">
                              <ul class="nav nav-pills card-header-pills justify-content-end w-100">

                                <li class="nav-item">
                                    <b-form-checkbox @click="storeAutomation" v-model="automationActive" switch size="lg">Automation {{ automationActive ? 'Running':'Paused' }}</b-form-checkbox>
                                    <!--<a class="btn btn-primary mr-1" href="#" @click="storeAutomation" title="Save"><i class="fa fa-save"></i></a>-->
                                    <!--<a class="btn btn-primary mr-1" href="#" @click="updateAutomationTree()" title="Save"><i class="fa fa-star"></i></a>-->
                                </li>
                                
                              </ul>
                            </div>

                          </div>
                          
                    </div>

                    <div class="card-body automation-builder-container tab-pane active" id="automationBuilderContainer" role="tabpanel" aria-labelledby="builder-tab">

                        <div class="row">

                        	<!--
                            <div class="col-12 col-md-3 builder-steps-nav" v-show="stepsNavActive" id="stepsNav">

                                  <a class="btn btn-primary btn-sm builder-step-nav-close d-none" href="javascript:;" @click="closePopupstepNav()"><i class="fa fa-close"></i></a>

                                  <b-nav vertical >

                                      <b-nav-item v-for="steptemplates in steptemplatesnav" :key="steptemplates.id"  class="step-template-nav" v-if="steptemplates.step_templates.length">


                                            <draggable :group="{ name: 'steps', pull: 'clone', put: false }" :sort="false"  :clone="initClonePopupstep" :list="steptemplates.step_templates">
                                              <div v-for="steptemplate in steptemplates.step_templates" :data-stepTemplateId="steptemplate.id" class="steptemplate">
                                                <a :id="'accordion_'+steptemplates.id+'_stepSelectLink_'+steptemplate.id" class="step-select" href="javascript:;" @click="selectPopupstep" :data-stepTemplateId="steptemplate.id">
                                                  <img class="step-preview" :src="steptemplate.thumbnail"/>
                                                  
                                                </a>
                                                <div v-if="steptemplates.user_id" class="step-nav-controls">
                                                  <i class="step-control btn btn-light fa fa-trash" @click="deleteCustomPopupstep(steptemplate.id)"></i>
                                                </div>
                                                <div v-if="steptemplates.company_id && manageCompanyCards" class="step-nav-controls">
                                                  <i class="step-control btn btn-light fa fa-trash" @click="deleteCompanyPopupstep(steptemplate.id)"></i>
                                                </div>
                                              </div>
                                            </draggable>

                                          

                                      </b-nav-item>

                                  </b-nav>

                            </div>
                        	-->

                            <div class="col automationbuilder-build-area sizzledeck d-flex flex-column align-items-center justify-content-center" id="automationBuildArea" >
                            
                            	<automation-step-tree v-if="tree.length" :dataTree="tree" @triggerAdd="addStep" @triggerEdit="editStep" @triggerDelete="deleteStep" :defaults="defaults"></automation-step-tree>
									
                              	<div v-if="!tree.length">
                              		<b-button @click="launchTriggerPop">Add Automation Trigger</b-button>
                              	</div>

                              
                                

                            </div>
                      

                        </div>

                    </div>

                    <div class="card-body  automation-config-container tab-pane" id="automationConfigContainer" role="tabpanel" aria-labelledby="config-tab">
                      
                      <div class="row">
                        <div class="col">

                        	  
                          
                            <b-form-group
                                id="input-group-automationname"
                                label="Automation Name:"
                                label-for="input-automationname"
                                description="Enter a name so you can identify the Automation."
                              >
                              <b-form-input
                                id="input-automationname"
                                v-model="automationName"
                                type="text"
                                placeholder="Enter a name"
                                required
                              ></b-form-input>
                            </b-form-group>
                          


                        </div>
                      </div>
                    </div>
  

                    <div class="card-footer pt-0 border-top-0">
                      <ul class="nav nav-tabs tabs-below" id="myTab" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link active" id="builder-tab" data-toggle="tab" href="#automationBuilderContainer" role="tab" aria-controls="builder" aria-selected="true" @click="activeTab('builder-tab')">Builder</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="config-tab" data-toggle="tab" href="#automationConfigContainer" role="tab" aria-controls="config" aria-selected="false" @click="activeTab('config-tab')">Settings</a>
                        </li>
                      </ul>
                      
                    </div>

                </div>
            
            </div>

        </div>

        <b-modal ref="choose-trigger-modal" id="choose-trigger-modal"  title="Choose Automation Trigger Event" ok-only no-close-on-esc no-close-on-backdrop hide-header-close ok-title="Done" @ok="storeAutomation">

          <div v-if="steps.length">
            <b-form-group>
      			  <b-form-select v-model="steps[0]['content']['trigger']" :options="[{'text':'Choose an event to Trigger this Automation','value':''},{'text':'Pop Up Form Fill','value':'popup-form-fill'}]"></b-form-select>
            </b-form-group>

      			<div v-if="steps[0]['content']['trigger']=='popup-form-fill'">
              <b-form-group>
                <b-form-select v-model="steps[0]['content']['popup']" :options="defaults.popups"></b-form-select>
              </b-form-group>
      			</div>
        	</div>

        </b-modal>

  		<b-modal ref="edit-step-type-wait-modal" id="edit-step-type-wait-modal"  title="Edit Wait Step" ok-only no-close-on-esc no-close-on-backdrop hide-header-close ok-title="Done" @ok="storeAutomation">
  			<div v-if="selectedStep && selectedStep.id && selectedStep.type=='wait'">
          <b-form-group><b-form-select v-model="steps.find(step => step.id == selectedStep.id)['content']['type']" :options="defaults.delay.type"></b-form-select></b-form-group>

          <div v-if="steps.find(step => step.id == selectedStep.id)['content']['type'] =='period'">
             <b-form-group> <b-form-input v-model="steps.find(step => step.id == selectedStep.id)['content']['period_value']" type="number"></b-form-input></b-form-group>
              <b-form-group><b-form-select v-model="steps.find(step => step.id == selectedStep.id)['content']['period_units']" :options="defaults.delay.period_units"></b-form-select></b-form-group>
          </div>

        </div>
  		</b-modal>

  		<b-modal ref="edit-step-type-deck-modal" id="edit-step-type-deck-modal"  title="Edit Send Deck Step" ok-only no-close-on-esc no-close-on-backdrop hide-header-close ok-title="Done" @ok="storeAutomation">
        <div v-if="selectedStep && selectedStep.id && selectedStep.type=='deck'">
          <b-form-group><b-form-select v-model="steps.find(step => step.id == selectedStep.id)['content']['deck']" :options="defaults.template_decks"></b-form-select></b-form-group>

          <b-form-group v-if="steps.find(step => step.id == selectedStep.id)['content']['deck']">
             <b-form-textarea
                v-model="steps.find(step => step.id == selectedStep.id)['content']['sms']"
                placeholder="SMS Message"
                rows="3"
                max-rows="6"
              ></b-form-textarea>

          </b-form-group>

        </div>
  		</b-modal>

      <b-modal ref="edit-step-type-sms-modal" id="edit-step-type-sms-modal"  title="Edit Send SMS Step" ok-only no-close-on-esc no-close-on-backdrop hide-header-close ok-title="Done" @ok="storeAutomation">
        <div v-if="selectedStep && selectedStep.id && selectedStep.type=='sms'">

          <b-form-group><b-form-select v-model="steps.find(step => step.id == selectedStep.id)['content']['user']" :options="defaults.company_users"></b-form-select></b-form-group>

          <b-form-group v-if="steps.find(step => step.id == selectedStep.id)['content']['user']">
             <b-form-textarea
                v-model="steps.find(step => step.id == selectedStep.id)['content']['sms']"
                placeholder="SMS Message"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
          </b-form-group>

        </div>
      </b-modal>

      <b-modal ref="edit-step-type-logic-modal" id="edit-step-type-logic-modal"  title="Edit logic Step" ok-only no-close-on-esc no-close-on-backdrop hide-header-close ok-title="Done" @ok="storeAutomation">
        <div v-if="selectedStep && selectedStep.id && selectedStep.type=='logic'">

          <b-form-group><b-form-select v-model="steps.find(step => step.id == selectedStep.id)['content']['logic']" :options="[{'text':'Choose a condition','value':''},{'text':'If deck opened','value':'deck-open'}]"></b-form-select></b-form-group>
          <b-form-group v-if="steps.find(step => step.id == selectedStep.id)['content']['logic']"><b-form-select v-model="steps.find(step => step.id == selectedStep.id)['content']['deck']" :options="defaults.template_decks"></b-form-select></b-form-group>

        </div>
      </b-modal>

    </div>


</template>
<script>

  import axios from 'axios';
  import Noty from 'noty';

    export default {
        mounted() {
          var vm = this;
          vm.csrfToken = $('meta[name="csrf-token"]').attr('content');

          axios.get('/automation/defaults').then(response => {

              vm.defaults = response.data;

              /*
              if(vm.defaults.popups.length){
                var popups = [];
                vm.defaults.popups.forEach(function(popup){
                  popups.push({'value':popup.id,'text':popup.name})
                });
                vm.defaults.popups = popups;
              }
			       */

              if(vm.automationId){
                vm.loadAutomation();
              }else{
                vm.storeAutomation();
              }
              this.isMounted = true;

          }).catch(() => console.warn('Oh. Something went wrong with mounted.'));        

        },
        props: [
            'id',
        ],
        data: function(){

            return {
                isMounted: false,

                automationId: this.id,

                automationName: 'Untitled',

                automationActive: true,

                companyUsers: [{value: null, text: 'Loading...'}],

                automationNotify: null,

                templateDecks: [{value: null, text: 'No, don\'t send a deck'}],

                tabActive: 'builder-tab',

                steps:[],                
                tree:[],       
                
                defaults:[],

                selectedStep: null,

            }
        },
        methods:{
          loadAutomation: function(){
                var vm = this;
                const url = `/automation/get/`+vm.automationId;
                axios.get(url).then(response => {

                  vm.automationName = response.data.name;
                  vm.automationActive = Boolean(response.data.active);

                  response.data.steps.forEach(function(step){

                    //step.content = JSON.parse(step.content);

                    vm.steps.push(step);

                  });

                  vm.updateAutomationTree();

                }).catch(() => console.warn('Oh. Something went wrong. loadAutomation'));
          },
        	storeAutomation: function(){ 

                const url = `/automation/save`;

                var vm = this;

                axios.post(url,{id:vm.automationId,name:vm.automationName,active:vm.automationActive,steps:vm.steps}).then(response => {
                    
                      if(response.data.status == 'success'){

                        vm.automationId = response.data.payload.id;
                        vm.automationName = response.data.payload.name;
                        vm.automationActive = Boolean(response.data.payload.active);
                        window.history.pushState("", "", "/automation/edit/"+vm.automationId);
                        
                        vm.updateAutomationTree();
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

                }).catch( error => {

                      if(error.response.status == '419'){

                        new Noty({
                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: false
                            }).show();

                      }else{

                      new Noty({
                                text: 'There has been an error, please try saving again.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: false
                            }).show();
                    }
              });

          },
          storeStep: async function(step){ 

                

                var vm = this;
                const url = `/automation/save-step`;
                axios.post(url,{id:vm.automationId,step:step}).then(response => {
                    
                      if(response.data.status == 'success'){

                        return response.data.payload.id;
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

                }).catch(() => console.warn('Oh. Something went wrong. storeStep'));

                
          },
        	updateAutomationTree:function(){
        		var vm = this;
            //console.log('vm.steps',vm.steps);
        		vm.tree = vm.createAutomationTree(vm.steps)
        	},
        	createAutomationTree:function(dataset){

	        	/* Source: https://stackoverflow.com/questions/18017869/build-tree-array-from-flat-array-in-javascript */
    				const hashTable = Object.create(null);
    				dataset.forEach(aData => hashTable[aData.id] = {...aData, childNodes: []});
    				const dataTree = [];
    				dataset.forEach(aData => {
    					if(aData.parent_id) hashTable[aData.parent_id].childNodes.push(hashTable[aData.id])
    					else dataTree.push(hashTable[aData.id])
    				});
    				return dataTree;

			    },
			addStep: function(args){
				
        
				var parent_id = args.parent_id;
				var type = args.type;
        var logic = args.logic;

				var vm = this;

				switch(type){
					case 'trigger':
						var nicename = 'Trigger Automation';
					break; 
          case 'wait':
            var nicename = 'Wait';
          break; 
					case 'deck':
						var nicename = 'Send SizzleDeck';
					break; 
					case 'sms':
						var nicename = 'Send SMS';
					break; 
					case 'logic':
						var nicename = 'Logic / Branch';
					break; 
					default:
						var nicename = '';
					break
				}

        // Need to store step initally to get an ID
        const url = `/automation/save-step`;
        axios.post(url,{id:vm.automationId,step:{'type':type,'parent_id':parent_id,'content':{'nicename':nicename}}}).then(response => {
            
              if(response.data.status == 'success'){

                var new_step_id = response.data.payload.id;
              
                // Iterate over steps with parent id and update parent id
                if(!logic){
                  for(var step of vm.steps){
                    if(parent_id && step.parent_id == parent_id){
                      step.parent_id = new_step_id;
                    }
                  }
                }
/*
                else{
                  for(var step of vm.steps){
                    if(parent_id && step.parent_id == parent_id){

                      if(logic=='if'){
                        step.content.if_step_id = new_step_id;
                      }
                      if(logic=='else'){
                        step.content.else_step_id = new_step_id;
                      }

                    }
                  }
                }
*/

                // Push new step to steps array
                vm.steps.push({'id':new_step_id,'type':type,'parent_id':parent_id,'content':{'nicename':nicename}});
                

                // Find Parent ID and update 'next_step' in content (if not logic step)
                for(var step of vm.steps.filter(step => step.id == parent_id)){
                  if(step.type !== 'logic'){ step.content.next_step = new_step_id; }else{
                    if(logic=='if'){
                      step.content.if_next_step = new_step_id;
                    }
                    if(logic=='else'){
                      step.content.else_next_step = new_step_id;
                    }
                  }
                }
                


                // Save whole updated automation
                vm.storeAutomation();

              }else{

                  new Noty({
                      text: response.data.message,
                      type: response.data.status,
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 1000
                  }).show();

              }

        })//.catch(() => console.warn('Oh. Something went wrong. storeStep'));



			},
          deleteStep:function(step_id){
            var vm = this;
            vm.selectedStep = null;  // Bugfix - clear seleted step: need to add to close popup event

            var step = vm.steps.find(step => step.id == step_id);

            var new_parent_id = step.parent_id;
            var new_next_step = step.content.next_step;

            // Iterate over steps with parent id and update parent id
            for(var step of vm.steps.filter(step => step.parent_id == step_id)){
              step.parent_id = new_parent_id;
            }            

            // update 'next_step' in content (if not logic step)
            for(var step of vm.steps.filter(step => step.content.next_step == step_id)){
              if(step.type !== 'logic'){ step.content.next_step = new_next_step; }
            }

            // Iterate over steps with parent id and update parent id
            for(var step of vm.steps.filter(step => step.id == new_parent_id)){
              if(step.type == 'logic'){
                if(step.content.if_next_step==step_id){
                  step.content.if_next_step = '';
                }
                if(step.content.else_next_step==step_id){
                  step.content.else_next_step = '';
                }
              }
            }            



/*
if(step.type == 'logic'){ step.content.next_step = new_step_id; }else{
                if(logic=='if'){
                  step.content.if_next_step = ;
                }
                if(logic=='else'){
                  step.content.else_next_step = new_step_id;
                }
*/


            vm.steps.splice(vm.steps.findIndex(step => step.id == step_id),1);
            


            vm.storeAutomation();
            
          },
        	editStep:function(step_id){

        		var vm = this;
            	var step = vm.steps.find(step => step.id == step_id);
        		switch(step['type']){
        			case 'trigger':
        				vm.launchTriggerPop(step_id);
        			break;
        			case 'wait':
        				vm.launchWaitPop(step_id);
        			break;
        			case 'deck':
        				vm.launchDeckPop(step_id);
        			break;
        			case 'sms':
        				vm.launchSMSPop(step_id);
        			break;
        			case 'logic':
        				vm.launchLogicPop(step_id);
        			break;
        		}
        	},
        	launchTriggerPop: function(e){
        		var vm = this;

        		if(!vm.steps.length){

              vm.addStep({parent_id:null,'type':'trigger'});

              //var new_step_id = vm.storeStep({'type':'trigger','content':{'trigger':'','nicename':'Automation Trigger'}});
        			//vm.steps.push({'id':new_step_id,'type':'trigger','content':{'trigger':'','nicename':'Automation Trigger'}});

        			//vm.storeAutomation();

        		}

            vm.$refs['choose-trigger-modal'].show();

			},
      launchDeckPop: function(step_id){
        		var vm = this;
        		vm.selectedStep = vm.steps.find(step => step.id == step_id);
           	vm.$refs['edit-step-type-deck-modal'].show();

			},
      launchSMSPop: function(step_id){
            var vm = this;
            vm.selectedStep = vm.steps.find(step => step.id == step_id);
            vm.$refs['edit-step-type-sms-modal'].show();

      },
      launchWaitPop: function(step_id){
        		var vm = this;
        		vm.selectedStep = vm.steps.find(step => step.id == step_id);
           	vm.$refs['edit-step-type-wait-modal'].show();

			},
      launchLogicPop: function(step_id){
            var vm = this;
            vm.selectedStep = vm.steps.find(step => step.id == step_id);
            vm.$refs['edit-step-type-logic-modal'].show();

      },
			activeTab: function(tab){
			  this.tabActive = tab;
			},
        }
    }
</script>
